module.exports = __webpack_public_path__ + "img/Aufrubbeln_Black.68f4c621.png";